/* eslint-disable max-len */
import React from 'react';
import ContentLoader from 'react-content-loader';

const styles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '80vh',
};

export const Loader: React.FC = () => {
  return (
    <div style={styles}>
      <ContentLoader
        speed={1}
        width={120.667}
        height={120.667}
        viewBox="0 0 1706.667 1706.667"
        backgroundColor="#89939A"
        foregroundColor="#905BFF"
      >
        <path d="M 420.2 105.1 c -17.1 2.2 -30 8.7 -42.8 21.4 c -7.5 7.4 -9.9 10.6 -13.6 18.2 c -2.6 5 -5.5 12.7 -6.5 17 c -1.7 7.5 -1.8 25.7 -1.8 478.8 c 0 448.7 0.1 471.3 1.8 478 c 1 3.8 3.8 11.3 6.4 16.5 c 3.9 8 5.9 10.8 13.7 18.5 c 7.6 7.6 10.6 9.9 18.6 13.8 c 18.3 9 -5.2 8.2 244 8.2 s 225.7 0.8 244 -8.2 c 8 -3.9 11 -6.2 18.6 -13.8 c 7.8 -7.7 9.8 -10.5 13.7 -18.5 c 2.6 -5.2 5.4 -12.7 6.4 -16.5 c 1.7 -6.7 1.8 -29.3 1.8 -478.5 s -0.1 -471.8 -1.8 -478.5 c -1 -3.9 -3.8 -11.3 -6.4 -16.5 c -3.9 -8 -5.9 -10.8 -13.7 -18.5 c -10.3 -10.3 -19.9 -16 -33.3 -19.8 l -7.8 -2.2 l -217.5 -0.1 c -119.6 -0.1 -220.3 0.2 -223.8 0.7 z m 268.6 70.1 c 1.8 1.8 1.5 9.4 -0.4 11.2 c -1.4 1.4 -7.1 1.6 -48.4 1.6 s -47 -0.2 -48.4 -1.6 c -1.9 -1.8 -2.2 -9.4 -0.4 -11.2 c 1.7 -1.7 95.9 -1.7 97.6 0 z M 874 640 v 381 H 406 V 259 h 468 v 381 z m -227 414.1 c 19.6 3.1 34.9 18.5 38.2 38.3 c 3.7 22.5 -11.3 45.2 -33.7 51.1 c -26 6.7 -52 -10.3 -56.6 -37.1 c -4.1 -23.9 13.2 -48.3 37.1 -52.3 c 7.6 -1.2 7.7 -1.2 15 0 z" />
      </ContentLoader>
    </div>
  );
};
